import { toast } from "react-toastify";
import { CLAIMS_HANDLER, METHOD, VENDOR_MANAGER } from "../../consts";
import { axiosClient } from "../../service";
import { REACT_APP_VAM_CONTEXT_SURVEYOR, REACT_APP_VAM_CONTEXT_VENDOR, REACT_APP_VAM_ENDPOINT } from "../../urls";
import { getFromDecreaptLocalStorage } from "../../utilFunctions";
import { isLastDayOfMonth } from "date-fns";


export const fieldKeys = {
    season: "season",
    year: "year",
    product: "product",
    state: "state",
    district: "district",
    mandal: "mandal",
    village: "village",
    surveyStatus: "surveyStatus",
    farmerId: "farmerId",
    farmerName: "farmerName",
    policyNumber: "policyNumber",
    surveyId: "SurveyId",
    vendorName: "vendorName",
    surveyorName: "surveyorName",
    startDate: "startDate",
    endDate: "endDate",
    pageNo: "pageNo",
    count: "count",
    downloadStatus: "downloadStatus",
}

export const getList = async (fieldValues, toast, setData, setIsLoading, pageNumber, pageSize) => {
    const roleDataCookie = getFromDecreaptLocalStorage("roleData")
    let vendorName = ""
    //check the user is vendor manger or not, if yes user should have surveyor details with user email else show error toast
    if (roleDataCookie?.roleName === VENDOR_MANAGER) {
        const vendorManagerDetails = getFromDecreaptLocalStorage("vendorManagerDetails")
        if (!(vendorManagerDetails?.vendorName && vendorManagerDetails.status === "Active")) {
            toast.error("You are not assigned to any vendor");
            return;
        } else {
            vendorName = vendorManagerDetails?.vendorName
        }
    }


    // Check for atleast one field is required
    const hasAnyValue = Object.keys(fieldKeys).some(key => {
        if(![fieldKeys.count, fieldKeys.pageNo].includes(key)) {
            const fieldKey = fieldKeys[key];
            const value = fieldValues[fieldKey];
            return value !== undefined && value !== null && value !== '';
        }
    });

    if (!hasAnyValue) {
        toast?.error("Please Input a search Parameter");
        return;
    }
    setIsLoading(true)
    axiosClient(`${REACT_APP_VAM_ENDPOINT}/${REACT_APP_VAM_CONTEXT_VENDOR}`)({
        url: 'survey-management/search',
        method: METHOD.POST,
        data: {
            seasonName: fieldValues[fieldKeys.season],
            seasonYear: fieldValues[fieldKeys.year],
            state: fieldValues[fieldKeys.state],
            district: fieldValues[fieldKeys.district],
            mandal: fieldValues[fieldKeys.mandal],
            village: fieldValues[fieldKeys.village],
            productType: fieldValues[fieldKeys.product]?.label,
            farmerId: fieldValues[fieldKeys.farmerId],
            farmerName: fieldValues[fieldKeys.farmerName],
            policyNumber: fieldValues[fieldKeys.policyNumber],
            surveyNumber: fieldValues[fieldKeys.surveyId],
            surveyorName: fieldValues[fieldKeys.surveyorName],
            surveyStatus: fieldValues[fieldKeys.surveyStatus]?.value,
            vendorName: fieldValues[fieldKeys.vendorName]?.vendorName || vendorName,
            fromDate: fieldValues[fieldKeys.startDate],
            toDate: fieldValues[fieldKeys.endDate],
            pageNo: pageNumber ?? fieldValues[fieldKeys.pageNo],
            count: pageSize ?? fieldValues[fieldKeys.count],
            assignedTo: roleDataCookie?.roleName === CLAIMS_HANDLER ? roleDataCookie?.userID:"",
            downloadStatus: fieldValues[fieldKeys.downloadStatus]?.value
        }
    }).then(data => {
        setData(data?.data)
    }).catch(error => {
        console.error(error)
    }).finally(() => {
        setIsLoading(false)
    })

}
export const getSurveyorList = (vendorId, setSurveyorsList) => {
    axiosClient(`${REACT_APP_VAM_ENDPOINT}/${REACT_APP_VAM_CONTEXT_SURVEYOR}`)({
        url: `getSurveyorAndQCMasterList/${vendorId}`,
        method: METHOD.GET,
    }).then(data => {
        setSurveyorsList(
            data.data.map((list) => {
                const fullName = list.lastName
                    ? `${list.firstName} ${list.lastName}`
                    : list.firstName;
                return {
                    label: `${fullName} (${list.mobileNumber})`,
                    value: `${fullName}`,
                };
            })
        );
    })
        .catch((error) => {
            console.error(error);
        });

};

export const getSurveyForm = async (surveyNumber, setIsLoading) => {
    let isDownloaded = false;
    setIsLoading(true)
    try {
        const response = await axiosClient(`${REACT_APP_VAM_ENDPOINT}/${REACT_APP_VAM_CONTEXT_VENDOR}`)({
            url: `download/${surveyNumber}`,
            method: METHOD.GET,
            responseType: 'blob',
            headers: {
                "Content-Type": "application/pdf",
            },
        });
        if (response?.status === 200) {
            const filename = `${surveyNumber}.pdf`;
            const blob = new Blob([response.data], { type: 'application/pdf' });
            const url = window.URL.createObjectURL(blob);

            const a = document.createElement('a');
            a.href = url;
            a.download = filename;
            document.body.appendChild(a);
            a.click();
            a.remove();
            window.URL.revokeObjectURL(url);

            isDownloaded = true;
        } else {
            toast.error('Unable to download survey form.');
        }

    } catch (error) {
        toast.error('Unable to download survey form.');
        console.error(error);
    }
    setIsLoading(false)
    return isDownloaded;
};

export const updateSurveyStatus = async (surveyNumber, status, setIsLoading) => {
    let isUpdated =false
    setIsLoading(true)
    try {
    const response = await axiosClient(`${REACT_APP_VAM_ENDPOINT}/${REACT_APP_VAM_CONTEXT_VENDOR}`)({
        url: `status`,
        method: METHOD.PUT,
        data: {
            fieldSurveyNumber: surveyNumber,
            status: status
        }
    })
    if(response?.status === 200) {
        isUpdated = true
    }
}catch(error) {
        isUpdated = false
        toast.error("Something went wrong")
        console.error("Error while updating survey form status: ", error)
    }
    setIsLoading(true)
    return isUpdated
}




export const getAging = (startDate, endDate, formatDistance) => {
    if (startDate) {
        return endDate ? formatDistance(new Date(startDate), new Date(endDate)) : formatDistance(new Date(startDate), new Date());
    }
    return "--"
}

export const surveyFormStatuses = {
    DOWNLOADED: "Downloaded",
    RE_DOWNLOAD: "Re-downloaded",
    APPROVAL_PENDING: "Approval Pending",
    APPROVED: "Approved"
}

export const reassignDefaultPayload = {
    claims: [],
    surveyorName: "",
    surveyorID: "",
    surveyorMobile: "",
    vendorName: "",
    comments: ""
};

export const actionDropdownList = [
    {
        label: "Download",
        value: "Download"
    },
    {
        label: "Re-download",
        value: "Re-Download"
    },
    {
        label: "Approval Pending",
        value: "Approval Pending"
    },
]